import React, {useEffect, useState} from "react";
//External
import {Col, Row} from "react-bootstrap";
import Select from "react-select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter,faCircleInfo} from "@fortawesome/free-solid-svg-icons/faFilter";
import {Modal, ModalBody, ModalHeader, ModalFooter,Button, Label} from "reactstrap";

//User defined
import "./styles/main.css";
import avatar from "../../assets/images/profile-picture-girl-1.jpeg";
import Icon from "../../components/Icon";
import Contact from "./Contact";
import OptionsBtn from "../../components/OptionsButton";
import { useUsersContext } from "../../context/usersContext";
import {getOpenChatCount, loadContactsData, showToast, setSessionValue} from "../../../../Common/Appcommon";
import requestApi from "../../../../services/requestApi.service";
import cx from "classnames";

const Sidebar = () => {
	const { users: contacts, loadUsers, refreshContacts } = useUsersContext();
	const backButtonRef = React.useRef(null);
	let filterOptions = [
		{value: "All", label: "All"},
		{value: "Mine", label: "Mine"},
		//{value: "Unassigned", label: "Unassigned"},
		//{value: "Spam", label: "Blocked/Spam"},
	];
	let statusFilterOptions = [
		{value: "Open", label: "Open"},
		{value: "Closed", label: "Resolved"},
	];
	const [filterOption, setFilterOption] = useState(filterOptions[0]);
	const [statusFilterOption, setStatusFilterOption] = useState(statusFilterOptions[0]);
	const [toggleFilterModal, setToggleFilterModal] = useState(false);
	const [crmUser, setCrmUsers] = useState(null);
	const [crmUserFilterOptions, setCrmUserFilterOptions] = useState([]);
	const [contactSearch, setContactSearchOption] = useState([]);
	useEffect(() => {
		(async () => {
			await loadCrmUsersList();
		})();
		return () => {
			// this now gets called when the component unmounts
		};
	}, []);

	const applyFilterOption = async (option, filterName = "") =>{
		if(filterName == "userFilter") {
			setCrmUsers(option);
			return;
		}
		if(filterName == "dataFilter") {
			setFilterOption(option);
		} else if(filterName == "statusFilter") {
			setStatusFilterOption(option);
		}
		//We moved these filters inside modal. so load the updated data only after clicking apply button.
		//await loadContactDataWithFilter();
	}

	const loadContactDataWithFilter = async(isOnSearch = false) => {
		let filterOptions = [];
		filterOptions.push({name: "dataFilter", value: filterOption.value});
		filterOptions.push({name: "statusFilter", value: statusFilterOption.value});

		//update user filter only All applied in datafilter.
		if(crmUser !== null && crmUser.value !== undefined && crmUser.value !== null && filterOption.value !== undefined && filterOption.value === 'All') {
			filterOptions.push({name: "userFilter", value: crmUser.value});
		}
		if(contactSearch.value !== undefined && contactSearch.value !== null) {
			if(contactSearch.value !== ''){
				filterOptions = [];
				filterOptions.push({name: "contactSearch", value: contactSearch.value});
			}
		}
		let response = await loadContactsData(filterOptions);
		if(response.issuccess) {
			let contacts = response.data;
			loadUsers(contacts);
			getOpenChatCount(contacts);
			setSessionValue("filterOption" , JSON.stringify(filterOptions));
		} else if (response.errormsg !== ""){
			showToast(response.errormsg, "top-right","error");
		}
	}

	const closeFilterModal = () => {
		setToggleFilterModal(false);
	};

	const detectEnterPress = async (e) => {
		if (e.key === "Enter"){
			await loadContactDataWithFilter();
			e.preventDefault()
		}
	};

	let timeoutId;
	const onSeachKeyup = (e) => {
		//clearTimeout(timeoutId);
		let name = e.target.name;
		let value = e.target.value;
		let option = {value : value};
		setContactSearchOption(option);
		/*timeoutId = setTimeout(async () => {
			await onSeachChange(e);
		}, 500);*/
	};

	const onSeachChange = async (e) => {
		let name = e.target.name;
		let value = e.target.value;
		if(value === "") {
			let option = {value: value};
			setContactSearchOption(option);
			await loadContactDataWithFilter(true);
		}
	}

	const onCancelSearch = async (e) =>{
		setContactSearchOption([]);
		let response = await loadContactsData();
		if (response.issuccess) {
			backButtonRef.current.blur();
			let contacts = response.data;
			loadUsers(contacts);
			getOpenChatCount(contacts);
		}
	}

	const loadCrmUsersList = async() => {
		let params = {
			"ENTITY": "WHATSAPPPROCESS",
			"OPERATION": "GETUSERS",
			"FORMNAME": process.env.REACT_APP_MESSAGES_FORMNAME,
			"isOtherApiReq" : true,
		}
		let response = await requestApi.processServerRequest(params, "Mobile");
		if(response.issuccess) {
			let crmUsers = response.data;
			let crmUserFilterOptions = [];
			crmUsers.map((crmUser,index)=> {
				let userInfo = {value: crmUser['id'], label: crmUser['Name']};
				//set empty user by default.
				/*if(index == 0){
					setCrmUsers(userInfo);
				}*/
				crmUserFilterOptions.push(userInfo)
			});
			setCrmUserFilterOptions(crmUserFilterOptions);
		} else if (response.errormsg != ""){
			showToast(response.errormsg, "top-right","error");
		}
	};
	const onApplyAssignToFilter = async () => {
		setToggleFilterModal(false);
		await loadContactDataWithFilter();
	};

	return (
		<aside className="sidebar">
			<header className="header hide">
				<div className="sidebar__filter-wrapper">
					<Row>
						<Col md={"6"}>

						</Col>
						<Col md={"4"} className={'margin-nil padding-nil'}>
						</Col>
						<Col md={"2"}>
							<div className={'sidebar-filter-icon cursor-pointer'} onClick={setToggleFilterModal}>
								<i className="pe-7s-filter"> </i>
							</div>
						</Col>
					</Row>
					<Modal isOpen={toggleFilterModal} toggle={setToggleFilterModal}
						   className={'le-modal-sm'}>
						<ModalHeader
							toggle={closeFilterModal}>Filter conversations by</ModalHeader>
						<ModalBody>
							<div className={`mb-3`}>
								<Label className={`chat__userfilter`} >Status</Label>
								<Select
									classNamePrefix="le-select"
									required={true}
									onChange={(e) => {applyFilterOption(e, "statusFilter")}}
									value={statusFilterOption}
									name="status-filter-options"
									id="status-filter-options"
									options={statusFilterOptions}
								/>
							</div>
							<div className={`mb-3`}>
								<Label className={`chat__userfilter`} >Show conversations</Label>
								<Select
									classNamePrefix="le-select"
									required={true}
									onChange={(e) => {applyFilterOption(e, "dataFilter")}}
									value={filterOption}
									name="filter-options"
									id="filter-options"
									options={filterOptions}
								/>
							</div>
							<div className={cx(
								`mb-3`,
								{'hide': filterOption.value !== undefined && filterOption.value !== 'All'}
							)}>
								<Label className={`chat__userfilter`} >Owner</Label>
								<Select
									classNamePrefix="le-select"
									required={true}
									onChange={(e) => {applyFilterOption(e,"userFilter")}}
									value={crmUser}
									name="user-filter-options"
									id="filter-options"
									options={crmUserFilterOptions}
									isClearable={true}
									placeholder={` – choose –`}
								/>
							</div>
						</ModalBody>
						<ModalFooter>
							<Button className={`le-button lePrimaryBtn br-4`} color="primary" onClick={onApplyAssignToFilter}>
								Apply
							</Button>
						</ModalFooter>
					</Modal>
				</div>
				<div className="sidebar__avatar-wrapper hide">
					<img src={avatar} alt="Karen Okonkwo" className="avatar" />
				</div>
				<div className="sidebar__actions hide">
					<button className="sidebar__action" aria-label="Status">
						<Icon
							id="status"
							className="sidebar__action-icon sidebar__action-icon--status"
						/>
					</button>
					<button className="sidebar__action" aria-label="New chat">
						<Icon id="chat" className="sidebar__action-icon" />
					</button>
					<OptionsBtn
						className="sidebar__action"
						ariaLabel="Menu"
						iconId="menu"
						iconClassName="sidebar__action-icon"
						options={[
							"New group",
							"Create a room",
							"Profile",
							"Archived",
							"Starred",
							"Settings",
							"Log out",
						]}
					/>
				</div>
			</header>
			{/* <Alert /> */}
			<div className="search-wrapper">
				<div className="search-icons">
					<Icon id="search" className="search-icon" />
					<button ref={backButtonRef} onClick={(e) => {onCancelSearch(e)}} className="search__back-btn">
						<Icon id="back" />
					</button>
				</div>
				<input className="search form-control" onBlur={onSeachChange} value={contactSearch['value'] !== undefined ? contactSearch['value'] : ""} onKeyDown={detectEnterPress}  onChange={(e) => {onSeachKeyup(e)}} placeholder="Search or start a new chat" />
				<div className={'filter-icon cursor-pointer'} onClick={setToggleFilterModal}>
					<FontAwesomeIcon icon={faFilter} />
				</div>
			</div>
			<div className={cx("sidebar__contacts", {
				'no-conversations': contacts.length == 0
			})} >
				{contacts.length > 0 ?
					contacts.map((contact, index) => (
						<Contact key={index} contact={contact} />
					)) :
					<div>No conversations here...</div>
				}
			</div>
		</aside>
	);
};

export default Sidebar;
